import { z } from "zod";

import { BasicInfoSchema } from "./basic-info.schema";
import { GeneralidadesSchema } from "./generalidades.schema";
import { RepresentanteLegalSchema } from "./representante-legal.schema";
import { FinancialInfoSchema } from "./financial-info.schema";
import { accionistasStepSchema } from "./accionistas.schema";
import { JuntaDirectivaSchema } from "./junta-directiva.schema";
import { InternationalInfoSchema } from "./internacional-info.schema";
import { AutorizacionesSchema } from "./pep-autorizaciones.schema";

/**
 * Global schema (contiene todos los steps del formulario)
 */
export const GlobalFormSchema = z
  .object({
    generalidades: GeneralidadesSchema,
    informacionBasica: BasicInfoSchema,
    representanteLegal: RepresentanteLegalSchema.optional(),
    informacionFinanciera: FinancialInfoSchema.optional(),
    accionistas: accionistasStepSchema.optional(),
    juntaDirectiva: JuntaDirectivaSchema.optional(),
    operacionesInternacionales: InternationalInfoSchema.optional(),
    autorizaciones: AutorizacionesSchema.optional(),
  })
  .superRefine((data, ctx) => {
    // Regla: Si el tipoDocumento es NIT → representanteLegal requerido
    if (data.informacionBasica.tipoDocumento === "NIT") {
      if (!data.representanteLegal) {
        ctx.addIssue({
          path: ["representanteLegal"],
          code: "custom",
          message:
            "Debe diligenciar representante legal si el documento es NIT",
        });
      }
    }
  });

export type GlobalFormData = z.infer<typeof GlobalFormSchema>;
